import { NavLink } from 'react-router';
import { FileWarning, Receipt } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Pestana {
  a: string;
  etiqueta: string;
  icono: LucideIcon;
}

const PESTANAS: Pestana[] = [
  { a: '/catalogos', etiqueta: 'Conceptos facturables', icono: Receipt },
  { a: '/catalogos/motivos-de-correccion', etiqueta: 'Motivos de corrección', icono: FileWarning },
];

export function PestanasDeCatalogos() {
  return (
    <nav
      aria-label="Catálogos del sistema"
      className="mb-6 flex gap-1 overflow-x-auto border-b border-armazon-200"
    >
      {PESTANAS.map(({ a, etiqueta, icono: Icono }) => (
        <NavLink
          key={a}
          to={a}
          end={a === '/catalogos'}
          className={({ isActive }) =>
            [
              'flex shrink-0 items-center gap-2 border-b-2 px-4 py-3 text-[13px] font-semibold uppercase tracking-wide transition-colors',
              isActive
                ? 'border-marca-600 text-armazon-900'
                : 'border-transparent text-armazon-400 hover:text-armazon-600',
            ].join(' ')
          }
        >
          {({ isActive }) => (
            <>
              <Icono
                className={`size-4 shrink-0 ${isActive ? 'text-marca-600' : ''}`}
                aria-hidden
              />
              {etiqueta}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
